<template>
    <label class="form-label fw-bolder text-dark fs-6 mb-1">
        {{ title }}
    </label>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        }
    }
}
</script>
